import { useDataChange, useDataValue } from 'Simple/Data.js'

export function useOnFilterClickRefund(props) {
  let current = useDataValue({
    context: 'tab',
    path: 'selected.ledger.notes.filter_by',
    viewPath: props.viewPath,
  })

  let change = useDataChange({
    context: 'tab',
    path: 'selected.ledger.notes.filter_by',
    viewPath: props.viewPath,
  })

  return function onClick() {
    if (current.length === 0) {
      change(['refund'])
      return
    }

    if (current.includes('refund')) {
      let newSelected = current.filter(item => item !== 'refund')
      change(newSelected)
    } else {
      change([...current, 'refund'])
    }
  }
}

export function getCount(notes, type) {
  return notes.filter(item => item.type === type).length
}
